<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Lịch sử tạo KPI</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="$router.push({ name: 'kpi record list' })"
        >
          Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <InputRangeRaw
              v-model="createdDateRange"
              placeholder="Thời gian tạo"
              clearable
              :max-date="new Date()"
            ></InputRangeRaw>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.filename"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên file"
              @keyup.enter="submitForm"
            />
          </div>
          <div class="form-group">
            <!-- dataRegion -->
            <Select2
              v-model="search.regionId"
              :options="Config.getSearch(dataRegion)"
              placeholder="Vùng"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.creatorId"
              :options="Config.getSearch(optionsListUser)"
              placeholder="Người tạo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.serviceType"
              :options="Config.getSearch(Config.serviceType)"
              placeholder="Loại dịch vụ"
            />
          </div>

          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
              show-empty
              empty-text="Không có dữ liệu!"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(filename)="data">
                <router-link
                  class="link"
                  target="_blank"
                  :to="`/kpi-record/upload/detail/${data.item.id}`"
                  >{{ data.item.filename || 'filename' }}</router-link
                >
              </template>
              <template #cell(createdTime)="data">
                <p>{{ data.item.createdTime | formatDate('DD/MM/YYYY HH:mm:ss') }}</p>
              </template>
              <template #cell(type)="data">
                <p>{{ Config.getText(data.item.type, Config.createdFileBy) }}</p>
              </template>
              <template #cell(serviceType)="data">
                <p>
                  {{ Config.getText(data.item.serviceType, Config.serviceType) }}
                </p>
              </template>
              <template #cell(creator)="data">
                <p><b>Tên:</b> {{ data.item.creator.name }}</p>
                <p><b>Email:</b> {{ data.item.creator.username }}</p>
                <p><b>SĐT:</b> {{ data.item.creator.mobile }}</p>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { DeviceService } from '@/services/device.service'

  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import kpiRecordMx, { getListUserFn } from './kpiRecordMx'
  import InputRangeRaw from '../../components/InputRangeRaw.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'createdTime', label: 'Thời gian tạo', thStyle: '' },
    { key: 'filename', label: 'Tên file upload', thStyle: '' },
    { key: 'creator', label: 'Người thực hiện', thStyle: '' },
    { key: 'regionName', label: 'Vùng', thStyle: '' },
    { key: 'serviceType', label: 'Loại dịch vụ', thStyle: '' },
    { key: 'type', label: 'Hình thức tạo', thStyle: '' },
    { key: 'note', label: 'Ghi chú', thStyle: '' },
  ]

  const rawSearch = {
    limit: 20,
    page: 1,
    creatorId: null,
    filename: null,
    serviceType: null,
  }
  export default {
    components: { InputRangeRaw },
    mixins: [kpiRecordMx],

    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        search: cloneDeep(rawSearch),
        pagination: {
          total: 0,
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        createdDateRange: null,
        // option
        optionsListUser: [],
        dataRegion: [],
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
      this.getListUser()
      this.getRegion()
    },

    methods: {
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      removeForm() {
        this.search = cloneDeep(rawSearch)
        this.createdDateRange = null
        this.fetchData()
      },
      async getRegion() {
        try {
          const data = await StaffService.getListRegions()
          if (data.data.length > 0) {
            this.dataRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListUser() {
        this.optionsListUser = await getListUserFn()
      },
      async fetchData() {
        try {
          this.tbLoading = true

          this.search.createDateFrom = null
          this.search.createDateTo = null
          if (this.createdDateRange?.start && this.createdDateRange?.end) {
            this.search.createDateFrom = moment(this.createdDateRange.start)
              .startOf('day')
              .valueOf()
            this.search.createDateTo = moment(this.createdDateRange.end).endOf('day').valueOf()
          }
          const params = {
            // "code": "string",
            // "createDateFrom": 0,
            // "createDateTo": 0,
            // "creatorId": "string",
            // "filename": "string",
            // "limit": 0,
            // "page": 0,
            // "projectionList": [
            //   "string"
            // ],
            // "regionId": "string",
            // "sortResultList": [
            //   {
            //     "direction": "string",
            //     "field": "string"
            //   }
            // ],
            // "status": "string",
            // "successDateFrom": 0,
            // "successDateTo": 0
            ...rawSearch,
            ...this.search,
          }
          // remove data null and '0'
          for (const key in params) {
            if (
              params[key] === null ||
              params[key] === '0' ||
              (Array.isArray(params[key]) && params[key].length === 0)
            ) {
              delete params[key]
              delete this.search[key]
            }
          }
          console.log(123, params)
          const response = await DeviceService.orderKpiGetList(params)
          if (response.code === 1000) {
            this.lists = response.data.kpiFileUploadRes
            this.pagination.total = response.data.count
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
